import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=235582e9&scoped=true&lang=pug"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=235582e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235582e9",
  null
  
)

export default component.exports